export const validateObjectId = (value: string) =>
  value.match(/^[0-9a-fA-F]{24}$/);
